"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TerminateEmployee;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const UserContext_1 = require("../contexts/UserContext");
const react_native_paper_1 = require("react-native-paper");
const Button_1 = __importDefault(require("../components/Button"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const Employees_1 = __importDefault(require("../api/Employees"));
const react_native_paper_dates_1 = require("react-native-paper-dates");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function TerminateEmployeeHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.PersonCircleMinus, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": props['aria-label'], style: { color: THEME.Text, fontWeight: '500', fontSize: size != 'sm' ? 18 : 16, marginLeft: 8 }, children: props.text }), !!props.subText && (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, marginLeft: 8 }, children: props.subText })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: 'borderless', onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
function TerminateEmployeeForm(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('done');
    const [page, setPage] = react_1.default.useState(1);
    const [timeAndAttendance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance'));
    const [isKronosClient] = react_1.default.useState(timeAndAttendance?.isEnabled && timeAndAttendance?.vendor?.toLowerCase() == 'kronos');
    const [termineeDetails, setTermineeDetails] = react_1.default.useState({
        employeeId: props.employeeId ?? '',
        firstName: '',
        middleInitial: '',
        lastName: '',
        reasonCodes: []
    });
    const [termDate, setTermDate] = react_1.default.useState(null);
    const [termDateError, setTermDateError] = react_1.default.useState(true);
    const [terminationReq, setTerminationReq] = react_1.default.useState({
        employeeId: props.employeeId ?? '',
        clientId: '',
        reasonCode: '',
        terminationDate: '',
        terminationReason: '',
        okayToRehire: '',
        ptoReqsBeforeTerm: '',
        ptoReqsAfterTerm: '',
        timeEntriesAfterTerm: '',
        accrualsBeforeDateAction: '',
        accrualsAfterDateAction: ''
    });
    const booleanOptions = [
        {
            label: t('common:text.yes'),
            value: 'Y',
        },
        {
            label: t('common:text.no'),
            value: 'N',
        },
    ];
    const ptoReqsBeforeTermOptions = [
        {
            label: t('employees:text.delAll'),
            value: 'Delete All',
        },
        {
            label: t('employees:text.rejAll'),
            value: 'Reject All',
        },
        {
            label: t('employees:text.appAll'),
            value: 'Approve All'
        }
    ];
    const ptoReqsAfterTermOptions = [
        {
            label: t('employees:text.delAll'),
            value: 'Delete All',
        },
        {
            label: t('employees:text.rejAll'),
            value: 'Reject All',
        }
    ];
    const timeEntriesAfterTermOptions = [
        {
            label: t('employees:text.ignore'),
            value: 'Ignore'
        },
        {
            label: t('employees:text.delAll'),
            value: 'Delete All'
        },
        {
            label: t('employees:text.delAllExceptTO'),
            value: 'Delete All Except TO'
        }
    ];
    const accrualsBeforeDateActionOptions = [
        {
            label: t('employees:text.calcAndUpdate'),
            value: 'Calculate and Update'
        },
        {
            label: t('employees:text.ignore'),
            value: 'Ignore'
        }
    ];
    const accrualsAfterDateActionOptions = [
        {
            label: t('employees:text.rollback'),
            value: 'Rollback'
        },
        {
            label: t('employees:text.ignore'),
            value: 'Ignore'
        }
    ];
    const formatDate = (dateString) => {
        let [month, day, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day).toLocaleDateString(Helper_1.Helper.deviceLanguage(), { month: 'short', year: 'numeric', day: 'numeric', timeZone: 'UTC' });
    };
    const changePage = (newPage) => {
        setPage(newPage);
        // Scroll to top
        if (props.scrollViewRef.current) {
            props.scrollViewRef.current.scrollTo({
                x: 0,
                y: 0,
                animated: true
            });
        }
    };
    const handleSubmit = react_1.default.useCallback(() => {
        setStatus('loading');
        if (!formHasErrors()) {
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                'feature': 'Terminate Employee',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId
            });
            promise.current?.cancel();
            promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Employees_1.default.terminateEmployee(token, terminationReq)))
                .then((result) => {
                if (result?.success) {
                    react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'success', message: t('employees:messages.termEESuccess') });
                    react_native_1.DeviceEventEmitter.emit('event.employeeTerminate');
                    props.onSaved();
                }
                else {
                    react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'error', message: t('employees:messages.termEEFailed') });
                    props.onSaved();
                }
            })
                .catch((e) => {
                var errorMsg = '';
                if (e?.status == 400) {
                    try {
                        var termError = JSON.parse(e.body);
                        errorMsg = t('employees:messages.termEEFailed') + ' ' + termError?.errorMessage;
                        react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'error', message: errorMsg });
                        termError?.errorMessage ? setStatus('done') : props.onSaved();
                    }
                    catch {
                        react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'error', message: t('employees:messages.termEEFailed') });
                        props.onSaved();
                    }
                }
                else {
                    react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'error', message: t('employees:messages.termEEFailed') });
                    props.onSaved();
                }
            });
        }
        else {
            react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'error', message: t('employees:messages.checkFields') });
            setStatus('done');
        }
    }, [terminationReq]);
    const close = () => {
        promise.current?.cancel();
        props.onCancel();
    };
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext
            .getToken()
            .then((token) => {
            Employees_1.default.getTerminationDetails(token, props.employeeId).then((r) => {
                if (r) {
                    setTermineeDetails(r);
                    setStatus('done');
                    react_native_1.DeviceEventEmitter.emit('event.termineeLoaded', { name: `${r.firstName} ${r.middleInitial} ${r.lastName}`.replace(/\s+/g, ' ') });
                }
                else {
                    setStatus('error');
                }
            });
        })
            .catch(() => {
            setStatus('error');
        }));
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
            react_native_1.DeviceEventEmitter.removeAllListeners('event.termineeLoaded');
            react_native_1.DeviceEventEmitter.removeAllListeners('event.employeeTerminate');
        };
    }, [refresh]);
    const setTerminationReqField = (fieldName, value) => {
        props.onIsChanged();
        setTerminationReq({
            ...terminationReq,
            [fieldName]: value
        });
    };
    // Check if an input field has a valid value
    const hasErrors = (field, value) => {
        switch (field) {
            case 'date':
                return value.length != 10;
            case 'text':
                return !value || /^\s*$/.test(value) ? true : false;
        }
    };
    const formHasErrors = () => {
        let error = termDateError
            || hasErrors('text', terminationReq.reasonCode)
            || hasErrors('text', terminationReq.okayToRehire)
            || (isKronosClient ? hasErrors('text', terminationReq.ptoReqsBeforeTerm) : false)
            || (isKronosClient ? hasErrors('text', terminationReq.ptoReqsAfterTerm) : false)
            || (isKronosClient ? hasErrors('text', terminationReq.timeEntriesAfterTerm) : false)
            || (isKronosClient ? hasErrors('text', terminationReq.accrualsBeforeDateAction) : false)
            || (isKronosClient ? hasErrors('text', terminationReq.accrualsAfterDateAction) : false);
        return error;
    };
    return ((status == 'done' && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [page == 1 &&
                (0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_dates_1.DatePickerInput, { selectTextOnFocus: true, animationType: 'fade', "aria-label": t('employees:labels.termDate'), dense: true, endYear: 2100, hasError: termDateError, hideValidationErrors: true, inputMode: 'start', label: `${t('employees:labels.termDate')} *`, locale: 'en', mode: 'outlined', onChange: (d) => {
                                    setTermDate(d);
                                    let dateStr = `${(d?.getUTCMonth() + 1).toString().padStart(2, '0')}/${d?.getUTCDate().toString().padStart(2, '0')}/${d?.getUTCFullYear()}`;
                                    setTerminationReqField('terminationDate', dateStr);
                                    setTermDateError(hasErrors('date', dateStr));
                                }, onChangeText: (value) => {
                                    setTerminationReqField('terminationDate', value);
                                    setTermDateError(hasErrors('date', value));
                                }, onValidationError: () => setTermDateError(true), presentationStyle: 'overFullScreen', saveLabel: t('common:buttons.confirm'), startYear: 1900, validRange: { startDate: new Date(1900, 0), endDate: new Date(2100, 0) }, value: termDate }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { error: hasErrors('text', terminationReq.reasonCode), list: termineeDetails.reasonCodes.sort((a, b) => a?.label > b?.label ? 1 : -1), label: `${t('employees:labels.termReason')} *`, setValue: (value) => setTerminationReqField('reasonCode', value), value: terminationReq.reasonCode }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { error: hasErrors('text', terminationReq.okayToRehire), list: booleanOptions, label: `${t('employees:labels.rehireOK')} *`, setValue: (value) => setTerminationReqField('okayToRehire', value), value: terminationReq.okayToRehire }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { accessible: true, "aria-label": t('employees:labels.termExplain'), dense: true, label: t('employees:labels.termExplain'), mode: 'outlined', multiline: true, numberOfLines: 4, onChangeText: (value) => setTerminationReqField('terminationReason', value), style: STYLES.input, value: terminationReq.terminationReason }) }), isKronosClient &&
                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { error: isKronosClient ? hasErrors('text', terminationReq.ptoReqsBeforeTerm) : false, list: ptoReqsBeforeTermOptions, label: `${t('employees:labels.ptoReqsBeforeTerm')} *`, setValue: (value) => setTerminationReqField('ptoReqsBeforeTerm', value), value: terminationReq.ptoReqsBeforeTerm }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { error: isKronosClient ? hasErrors('text', terminationReq.ptoReqsAfterTerm) : false, list: ptoReqsAfterTermOptions, label: `${t('employees:labels.ptoReqsAfterTerm')} *`, setValue: (value) => setTerminationReqField('ptoReqsAfterTerm', value), value: terminationReq.ptoReqsAfterTerm }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { error: isKronosClient ? hasErrors('text', terminationReq.timeEntriesAfterTerm) : false, list: timeEntriesAfterTermOptions, label: `${t('employees:labels.timeEntriesAfterTerm')} *`, setValue: (value) => setTerminationReqField('timeEntriesAfterTerm', value), value: terminationReq.timeEntriesAfterTerm }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { error: isKronosClient ? hasErrors('text', terminationReq.accrualsBeforeDateAction) : false, list: accrualsBeforeDateActionOptions, label: `${t('employees:labels.accrualsBeforeDateAction')} *`, setValue: (value) => setTerminationReqField('accrualsBeforeDateAction', value), value: terminationReq.accrualsBeforeDateAction }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { error: isKronosClient ? hasErrors('text', terminationReq.accrualsAfterDateAction) : false, list: accrualsAfterDateActionOptions, label: `${t('employees:labels.accrualsAfterDateAction')} *`, setValue: (value) => setTerminationReqField('accrualsAfterDateAction', value), value: terminationReq.accrualsAfterDateAction }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', text: t('common:buttons.cancel'), onPress: () => close() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: formHasErrors(), text: t('common:buttons.continue'), onPress: () => changePage(2) }) })] })] }), page == 2 &&
                (0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 16 : 14 }, children: t('employees:text.confirmEETerm') }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginTop: 18, marginBottom: 12, backgroundColor: THEME.UltraLightGray, borderRadius: 4, flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 6, borderBottomLeftRadius: 4, borderTopLeftRadius: 4, backgroundColor: THEME.Red } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, paddingVertical: 1, fontWeight: '500' }, children: `${termineeDetails.firstName} ${termineeDetails.middleInitial} ${termineeDetails.lastName}`.replace(/\s+/g, ' ') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, paddingVertical: 1 }, children: t('employees:labels.termDate') + ': ' + formatDate(terminationReq.terminationDate) })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', text: t('common:buttons.back'), onPress: () => changePage(1) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: formHasErrors() || userContext?.isImpersonated, text: t('common:buttons.confirm'), onPress: () => handleSubmit() }) })] })] })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }));
}
function TerminateEmployee(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const scrollViewRef = react_1.default.useRef(null);
    const [name, setName] = react_1.default.useState('');
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [isChanged, setIsChanged] = react_1.default.useState(false);
    const [isConfirming, setIsConfirming] = react_1.default.useState(false);
    const onClose = () => {
        if (isChanged) {
            setIsConfirming(true);
        }
        else {
            props.navigation.goBack();
        }
    };
    react_native_1.DeviceEventEmitter.addListener('event.termineeLoaded', (eventData) => onTermineeLoaded(eventData));
    const onTermineeLoaded = (result) => {
        setName(result?.name ?? '');
    };
    react_1.default.useEffect(() => {
        return () => react_native_1.DeviceEventEmitter.removeAllListeners('event.termineeLoaded');
    }, []);
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, needsConfirmation: isChanged, onConfirmation: () => setIsConfirming(true), children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsx)(TerminateEmployeeHeader, { "aria-label": t('company:text.termee'), text: t('company:text.termee'), subText: name, onClose: onClose }) }), (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: 'handled', ref: scrollViewRef, children: [isConfirming &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginBottom: 12, backgroundColor: THEME.UltraLightGray, borderRadius: 4, flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 6, borderBottomLeftRadius: 4, borderTopLeftRadius: 4, backgroundColor: THEME.Red } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12, flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, fontWeight: '500', paddingVertical: 1 }, children: t('common:text.sure') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, paddingVertical: 1 }, children: t('common:text.sureDescription') })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', text: t('common:buttons.back'), onPress: () => setIsConfirming(false) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.discard'), onPress: () => props.navigation.goBack() }) })] })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { display: isConfirming ? 'none' : undefined }, children: (0, jsx_runtime_1.jsx)(TerminateEmployeeForm, { employeeId: props.route.params.employeeId, onCancel: onClose, onSaved: props.onSave ?? props.navigation.goBack, navigation: props.navigation, scrollViewRef: scrollViewRef, onIsChanged: () => setIsChanged(true) }) })] })] }));
}
